import { Mail, Phone } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";

const COAST_IMG =
  "https://images.unsplash.com/photo-1553301139-3c610dd5b1cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxoYXdhaWklMjBvY2VhbiUyMHZvbGNhbmljJTIwbGFuZHNjYXBlJTIwY29hc3RsaW5lfGVufDB8fHx8MTc5MDM4NzcyNXww&ixlib=rb-4.1.0&q=85";

const founders = [
  {
    name: "James Bordenave",
    title: "President & Co-Founder",
    initials: "JB",
    phone: "808-491-3395",
    phoneHref: "tel:+18084913395",
    email: "jamesbordenave43@gmail.com",
  },
  {
    name: "Maria Lopez",
    title: "Vice President & Co-Founder",
    initials: "ML",
    phone: "808-315-4667",
    phoneHref: "tel:+18083154667",
    email: "bordenavebelle@gmail.com",
  },
];

export default function Founders() {
  return (
    <section id="leadership" className="relative overflow-hidden bg-basalt py-28 lg:py-40" data-testid="leadership-section">
      <img
        src={COAST_IMG}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-0 h-full w-1/2 object-cover opacity-10 [mask-image:linear-gradient(to_left,black,transparent)]"
      />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Leadership</Eyebrow>
          <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold tracking-tight text-sand sm:text-3xl lg:text-4xl" data-testid="leadership-heading">
            Rooted in Hawai'i. Relentless about pono — doing what is right.
          </h2>
          <p className="mt-5 max-w-2xl text-base text-mist">
            "Hale Pono" means the house of righteousness and correctness. Our founders built this
            firm on a simple belief: facilities caring for people with intellectual and
            developmental disabilities deserve advocates who treat compliance as a promise, not
            paperwork.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {founders.map((f, i) => (
            <Reveal key={f.name} delay={0.1 + i * 0.1}>
              <div
                className="group glass-card rounded-2xl p-8 transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-ochre/40 lg:p-10"
                data-testid={`founder-card-${f.name.toLowerCase().split(" ")[0]}`}
              >
                <div className="flex items-center gap-5">
                  <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-ochre/40 bg-ochre/10 font-display text-xl font-extrabold text-ochre">
                    {f.initials}
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-sand sm:text-2xl">{f.name}</h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-mist">
                      {f.title}
                    </span>
                  </div>
                </div>
                <div className="mt-8 flex flex-col gap-3 border-t border-sand/10 pt-6">
                  <a
                    href={f.phoneHref}
                    className="flex items-center gap-3 text-sm text-mist transition-colors duration-300 hover:text-ochre"
                    data-testid={`founder-phone-${f.name.toLowerCase().split(" ")[0]}`}
                  >
                    <Phone size={15} className="text-ochre" />
                    {f.phone}
                  </a>
                  {f.email && (
                    <a
                      href={`mailto:${f.email}`}
                      className="flex items-center gap-3 text-sm text-mist transition-colors duration-300 hover:text-ochre"
                      data-testid={`founder-email-${f.name.toLowerCase().split(" ")[0]}`}
                    >
                      <Mail size={15} className="text-ochre" />
                      {f.email}
                    </a>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
